import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Location from './Location';
import Loader from '../../../../common/ui/Loader';
import UsersService from '../../../../../services/UsersService';

export default class Locations extends Component {
  static propTypes = {
    user: PropTypes.object,
    companyLocations: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    getCompanyLocations: PropTypes.func.isRequired,
    getLocationsListAction: PropTypes.func.isRequired
  };

  state = {
    isLoading: true,
    newLocationFormIsOpen: false
  };

  componentDidMount () {
    Promise.all([
      this.getListOfLocations(),
      this.props.getLocationsListAction()
    ]).then(this._setDataLoaded);
  }

  _getCompanyId = () => UsersService.isAdmin() && this.props.match ? this.props.match.params.id : this.props.user.company_id;

  _setDataLoaded = () => this.setState({ isLoading: false });

  getListOfLocations = () => {
    const { getCompanyLocations } = this.props;
    getCompanyLocations(this._getCompanyId());
  };

  openNewLocationForm = () => {
    this.setState({
      newLocationFormIsOpen: true
    });
  };

  closeNewLocationForm = () => {
    this.setState({
      newLocationFormIsOpen: false
    });
  };

  render () {
    if (this.state.isLoading) {
      return <Loader />;
    }

    const { companyLocations, locationsList } = this.props;
    const { newLocationFormIsOpen } = this.state;
    const companyId = this._getCompanyId();
    const isEmployersProfile = UsersService.isEmployer();
    return (
      <Fragment>
        <div className='row'>
          { newLocationFormIsOpen ? (
            <Location
              isCreatingLocation
              isEmployersProfile={isEmployersProfile}
              closeNewLocationForm={this.closeNewLocationForm}
              locationsList={locationsList}
              company_id={companyId}
              getListOfLocations={this.getListOfLocations}
            />
          ) : (
            <div className='col-12'>
              <button className='button button-primary mb-3' onClick={this.openNewLocationForm}>New Location</button>
            </div>
          )}
        </div>
        <div className='row'>
          {companyLocations.length > 0 && companyLocations.map(location => (
            <Location
              key={location.id}
              isEmployersProfile={isEmployersProfile}
              location={location}
              locationsList={locationsList}
              company_id={companyId}
              getListOfLocations={this.getListOfLocations}
              UIShowConfirm={this.props.UIShowConfirm}
            />
          ))}
        </div>
      </Fragment>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Locations/index.js